<svelte:options tag='swc-primary-button' immutable={true} />

<script>

  import { get_current_component } from 'svelte/internal';
  import { initEventDispatcher } from '../helpers/init-event-dispatcher';

  export let text = '';

  const dispatch = initEventDispatcher(get_current_component());
  const onPress = (newValue) => dispatch('press', newValue);

</script>

<style>
  button {
    background: linear-gradient(90deg, #E530A6 0%, #FF43A5 100%);
    box-shadow: 0 6px 20px 0 rgba(255, 85, 170, 0.2);
    border-radius: 22px;
    border: none;
    color: #FFFFFF;
    font-size: 0.75em;
    letter-spacing: 1.33333px;
    text-transform: uppercase;
    padding: 13px 0 14px;
    margin: 0 auto;
    display: block;
    font-family: inherit;
    font-weight: 600;
    cursor: pointer;
    user-select: none;
    width: 100%;
  }
</style>

<button on:click={onPress}>{text}</button>
